function AAFResolveException(type, message, data) {
    this.name = "AAFResolveException";
    this.type = type;
    this.message = message;
    this.data = data;
 }

 export default AAFResolveException;


// WEBPACK FOOTER //
// ./src/AAFPlayer/common/AAFResolveException.js